import {styled} from "@mui/system";
import {Avatar, Box} from "@mui/material";

export const CenteredBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
});

export const ColoredAvatar = styled(Avatar)(({background}) => ({
    backgroundColor: background,
    width: 20,
    height: 20,
}));